import React, { useEffect } from 'react'
import Box from '@material-ui/core/Box'
import ActivityRecordDetailForm from '../../../components/admin/activity/ActivityRecordDetailForm'
import ActivityRecordDetailTable from '../../../components/admin/activity/ActivityRecordDetailTable'
import useGDK from '../../../providers/admin/gdk/useGDK'
import { Branch } from '@golden/gdk-admin'

const ActivityRecordDetailPage: React.FC = () => {
  const gdk = useGDK()
  useEffect(() => {
    gdk.trunk.trigger([Branch.ACTIVITY])
  }, [gdk])
  return (
    <Box paddingY={5}>
      <Box paddingX={5}>
        <ActivityRecordDetailForm />
      </Box>
      <Box paddingTop={3}>
        <ActivityRecordDetailTable />
      </Box>
    </Box>
  )
}

export default React.memo(ActivityRecordDetailPage)
